import { BarChart3 } from 'lucide-react';
import { RecordCard } from '@/components/shared/record-card';
import { Pagination } from '@/components/shared/pagination';
import { cn } from '@/lib/utils';
import { ROLE_LABELS } from './team-labels';
import type { TeamUser } from '@/types';

type PaginationMeta = NonNullable<NonNullable<Parameters<typeof Pagination>[0]>['meta']>;

interface Props {
  users: TeamUser[];
  pagination?: PaginationMeta;
  onPageChange: (page: number) => void;
  onOpen: (user: TeamUser) => void;
}

/** Vista móvil (card layout) de "Mi Equipo". Oculta en `md+`. */
export function TeamCards({ users, pagination, onPageChange, onOpen }: Props) {
  return (
    <div className="space-y-3 md:hidden">
      {users.map((user) => (
        <RecordCard
          key={user.id}
          title={`${user.first_name} ${user.last_name}`}
          subtitle={user.email}
          onClick={() => onOpen(user)}
          badge={
            <span
              className={cn(
                'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
                user.is_active
                  ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-600/20 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-gray-50 text-gray-500 ring-1 ring-gray-300/20 dark:bg-gray-900/30 dark:text-gray-400',
              )}
            >
              {user.is_active ? 'Activo' : 'Inactivo'}
            </span>
          }
          fields={[
            { label: 'Rol', value: ROLE_LABELS[user.role] ?? user.role },
            {
              label: 'Posiciones',
              value: user.user_positions?.map((up) => up.position.name).join(', ') || '—',
            },
          ]}
          actions={[{ label: 'Ver reportes', icon: BarChart3, onClick: () => onOpen(user) }]}
        />
      ))}
      {pagination && <Pagination meta={pagination} onPageChange={onPageChange} />}
    </div>
  );
}
